<template>
    <div class="crm-main-cont">
        <div>
            <a-button type="primary" @click="showUpload" :style="{marginRight: '20px'}">
                上传授权模板
            </a-button>
            <a-button type="primary" @click="updateMaxDowloadTimes" :style="{marginRight: '20px'}">
                修改企业最大下载档案次数
            </a-button>
            <a-spin tip="Loading..." :spinning="spinning">
                <a-table bordered rowKey="id" :dataSource="dataSource"
                         :columns="columns">
                    <template slot="code" slot-scope="text">
                        {{text == "template_file" ? "授权模板" : "其他文件"}}
                    </template>
                    <template slot="operation" slot-scope="text, record">
                        <div class="editable-row-operations">
                            <a :href="record.path">查看</a>
                        </div>
                    </template>
                </a-table>
            </a-spin>
        </div>
        <a-drawer
                title="上传模板文件"
                :width="500"
                @close="onClose"
                :visible="uploadFileVisable"
                :wrapStyle="{ height: 'calc(100% - 108px)', overflow: 'auto' }"
        >
            <a-form :form="form">
                <a-row>
                    <a-col :span="12">
                        <a-form-item label="文件类型" v-bind="layoutStyle">
                            <a-input
                                    defaultValue="授权模板"
                                    v-decorator="[
                                    'companyName'
                                ]"

                                    placeholder="授权模板"
                                    disabled/>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>

                    <a-col :span="12">
                        <a-form-item label="备注" v-bind="layoutStyle">

                            <a-input
                                    v-decorator="['remark']"
                                    :rows="2"
                                    placeholder="备注信息"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12">
                        <a-form-item label="文件" v-bind="layoutStyle">
                            <a-upload name="file" :multiple="false" :customRequest="customRequest"
                                      :showUploadList="false"
                                      :beforeUpload="beforeUpload" @change="handleChange">
                                <a-button>
                                    <a-icon type="upload"/>
                                    点击上传
                                </a-button>
                            </a-upload>
                            <a-button
                                    v-if="uploadFileVisable"
                                    @click="showDowload()">
                                <a-icon type="zoom-in"/>
                                点击下载
                            </a-button>
                        </a-form-item>
                    </a-col>
                </a-row>
                <div class="submit-btn">
                    <a-button @click="upload" type="primary"
                    >提交并启用模板
                    </a-button
                    >
                </div>
            </a-form>
        </a-drawer>
        <a-modal
                title="企业信用档案年度下载次数"
                :visible="updateVisible"
                @ok="updateHandleOk"
                :confirmLoading="confirmLoading"
                @cancel="handleCancel"
        >
            <p style="
    margin-bottom: 5px;
">{{ModalText}}</p>
            <a-input size="small" v-model="maxDowloadTimes" onkeyup="value=value.replace(/[^\d.]/g,'')"></a-input>
        </a-modal>

    </div>
</template>

<script>
    import {getListByCode, uploadFileJS} from "@/api/file/uploadF";
    import {mySelectmes, uoloadFilesq} from "../../api/http";
    import {getMaxDowload, setMaxDowload} from "@/api/self_management/creditArchives";
    import { mapState} from "vuex";

    const columns = [
        {
            title: '类型',
            dataIndex: 'code',
            key: "code",
            scopedSlots: {customRender: "code"},
        }, {
            title: '备注',
            dataIndex: 'remark',
            key: "remark",
        }, {
            title: '上传日期',
            dataIndex: 'createTime',
            key: "createTime",
        }, {
            title: '操作',
            dataIndex: "operation",
            scopedSlots: {customRender: "operation"}
        }
    ];
    export default {
        computed: {
            ...mapState(["downPath"]),
        },
        data() {
            return {
                maxDowloadTimes: "",
                confirmLoading: false,
                ModalText: "当前最大下载次数为: 3次",
                updateVisible: false,
                spinning: false,
                code: "template_file",
                loading: false,
                columns,
                imageUrl: "",
                formDirectional: this.$form.createForm(this),
                formSnatch: this.$form.createForm(this),
                form: this.$form.createForm(this),
                uploadFileVisable: false,
                dataSource: [],
                item: [],
                options: [],
                checked: "",
                proname: "",
                prointroduce: "",
                procharacter: "",
                applicationrequire: "",
                remarkinformation: "",
                subordinatebank: "",
                logindept: "",
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: 0
                },
                fileList: [{
                    uid: '-1',
                    name: 'xxx.png',
                    status: 'done',
                    url: '',
                }],
                uploadUrl: "",
                text: "",
                a: 'a',
                b: 'b',
                toggle: true,
                layoutStyle: {
                    labelCol: {
                        span: 7
                    },
                    wrapperCol: {
                        span: 16
                    }
                }
            }
        },
        //列表显示
        beforeRouteEnter(to, from, next) {
            getListByCode("template_file", 1, 15)
                .then(res => {
                    next(vm => {
                        vm.$ajaxAfter(res).then(() => {
                            if (res.data.success == "TRUE") {
                                vm.dataSource = res.data.data.page.list;
                                Object.assign(vm.pagination, {
                                    total: res.data.data.page.total,
                                    pageSize: res.data.data.page.pageSize,
                                    current: res.data.data.page.pageNum
                                })
                            }
                        })
                    })
                })
        },
        methods: {
            handleCancel(e) {
                console.log("handleCancel is running.");
                this.updateVisible = false;
            },
            updateMaxDowloadTimes() {
                getMaxDowload().then(res => {
                    this.$ajaxAfter(res).then(() => {
                        if (res.data.success == "TRUE") {
                            this.ModalText = "当前年度下载次数为: " + res.data.data.maxDowloadTimes;
                            this.updateVisible = true;
                        } else {
                            this.$message.error(res.data.message);
                        }

                    })
                }).catch(() => {
                    this.$message.error("服务器出错！请稍后再试!");
                });
            },
            updateHandleOk(e) {
                console.log("handleOk is running.");
                this.confirmLoading = true;
                setMaxDowload({maxDowloadTimes: this.maxDowloadTimes}).then(res => {
                    this.$ajaxAfter(res).then(() => {
                        if (res.data.success == "TRUE") {
                            this.updateVisible = false;
                            this.confirmLoading = false;
                            this.$message.success(res.data.message);
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                }).catch(() => {
                    this.$message.error("服务器出错！请稍后再试!");
                });
            },
            initList() {
                getListByCode(this.code, this.pagination.current, this.pagination.pageSize)
                    .then(res => {
                        this.$ajaxAfter(res).then(() => {
                            this.spinning = false;
                            this.dataSource = res.data.data.page.list;
                            Object.assign(this.pagination, {
                                total: res.data.data.page.total,
                                pageSize: res.data.data.page.pageSize,
                                current: res.data.data.page.pageNum
                            });
                        });
                    })
                    .catch(() => {
                        this.$message.error("服务器出错！请稍后再试!");
                    });
            },
            handleOk(e) {
                this.hide = false
            },
            //分页切换
            change(page) {
                this.pagination.current = page.current;
                this.initList();
            },
            onClose() {
                this.uploadFileVisable = false;
            },
            showUpload() {
                this.uploadFileVisable = true;
            },
            //下拉选择
            handleSelectChange(value) {
                this.hide = true;
                mySelectmes(value).then(res => {
                    if (res.data.success === "TRUE") {
                        this.spinning = false;
                        this.proname = res.data.data.page.proname;
                        this.prointroduce = res.data.data.page.prointroduce;
                        this.procharacter = res.data.data.page.procharacter;
                        this.applicationrequire = res.data.data.page.applicationrequire;
                        this.remarkinformation = res.data.data.page.remarkinformation;
                        this.subordinatebank = res.data.data.page.subordinatebank;
                        this.logindept = res.data.data.page.logindept;
                    }
                })
            },
            //上传按钮
            handleChange(info) {
                if (info.file.status !== 'uploading') {
                }
                if (info.file.status === 'done') {
                    this.$message.success(`${info.file.name} file uploaded successfully`);
                } else if (info.file.status === 'error') {
                    this.$message.error(`${info.file.name} file upload failed.`);
                }
            },
            beforeUpload() {
                return true;
            },
            customRequest(files) {
                this.text = files.text;
                let formData = new FormData();
                formData.append("file", files.file);

                uoloadFilesq(formData).then(res => {
                    if (res.data.success === "TRUE") {
                        this.uploadUrl = res.data.data.sqtys;
                        this.$message.success("文件上传成功!")
                        this.imageUrl = this.downPath + this.uploadUrl;
                        this.loading = false;
                    }
                }).catch(error => {
                    this.$message.error("上传错误，请重新上传")
                })
            },
            getDowloadUrl(path) {
                return path;
            },
            upload() {
                this.form.validateFields((err, values) => {
                    if (err) {
                        return;
                    }
                    uploadFileJS(this.code, this.imageUrl, values.remark)
                        .then(res => {
                            this.$ajaxAfter(res).then(() => {
                                if (res.data.success === "TRUE") {
                                    this.$message.success("上传成功，旧文件已废除");
                                    this.uploadFileVisable = false;
                                    this.initList();
                                }
                            })
                        })
                })
            }
        }
    }

</script>


<style scoped lang="less">
    .ant-btn {
        font-size: 12px;
    }

    .ant-table-wrapper {
        font-size: 12px;
        margin-top: 20px;
    }

    .ant-table-row > td {
        font-size: 12px;
    }

    .spin-content {
        border: 1px solid #91d5ff;
        background-color: #e6f7ff;
        padding: 30px;
    }

    .f14 {
        font-size: 14px;
    }

    .search-box {
        .ant-form-item {
            display: inline-block;
            min-width: 280px;
        }

        .ant-select {
            width: 100%;
        }
    }

    .btns-group button {
        margin-right: 10px;
    }

    .submit-btn {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        border-top: 1px solid #e9e9e9;
        padding: 10px 16px;
        background: #fff;
        text-align: right;
    }

    .ant-row > div {
        height: 63px;
    }

    .account-list {
        margin-top: 30px;
    }

    .editable-row-operations a {
        margin-right: 10px;
    }

    .account-info {
        margin-bottom: 10px;
    }

    .auto-label {
        font-size: 14px;
    }

    .auth-list {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e8e8e8;
        padding: 10px 0;
    }

    .menu-top {
        flex-shrink: 0;
        width: 120px;
    }

    .menu-two-item {
        margin: 10px 0;
    }

    .menu-two-item {
        margin: 10px 0;
        display: flex;
        align-items: center;
    }

    .menu-two-top {
        width: 110px;
        flex-shrink: 0;
    }

    .operation-item {
        line-height: 28px;
    }
</style>
